angular.module('galilai.creator').controller('CheckoutController', function($scope, $rootScope, $location, api, $timeout) {
    console.log('CheckoutController');

    $scope.credentials = null
    $scope.email = ''
    $scope.plansMode = 'trial'
    $scope.viewMode = 'checkout'
    $scope.started = false
    $scope.pix = {
        image: null,
        payload: null,
    }
    $scope.register = {
        email: null,
        name: null,
        cpf: null,
    }

    $scope.jobId = null

    const DEFAULT_PLAN = {
        id: 'premium',
        quantity: 1,
        period: 'monthly',
    }

    function validateCPF(cpf) {
        // Remove all non-digits
        cpf = cpf.replace(/\D/g, '')
        if ( !cpf || cpf.length != 11
                || cpf == "00000000000"
                || cpf == "11111111111"
                || cpf == "22222222222"
                || cpf == "33333333333"
                || cpf == "44444444444"
                || cpf == "55555555555"
                || cpf == "66666666666"
                || cpf == "77777777777"
                || cpf == "88888888888"
                || cpf == "99999999999" )
            return false
        var soma = 0
        var resto
        for (var i = 1; i <= 9; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
        resto = (soma * 10) % 11
        if ((resto == 10) || (resto == 11))  resto = 0
        if (resto != parseInt(cpf.substring(9, 10)) ) return false
        soma = 0
        for (var i = 1; i <= 10; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
        resto = (soma * 10) % 11
        if ((resto == 10) || (resto == 11))  resto = 0
        if (resto != parseInt(cpf.substring(10, 11) ) ) return false
        return true
    }

    function jwtDecode(jwt) {
        var parts = jwt.split('.')
        try {
            return JSON.parse(urlBase64Decode(parts[1]));
        } catch (e) {
            logError('Error decoding', {
                'param': jwt,
            })
            showError("{{__l('error.something_went_wrong')}}")
            throw e
        }
        return null
    }

    function urlBase64Decode(str) {
        let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        // Pad with '=' characters to make the length a multiple of 4
        while (base64.length % 4) {
            base64 += '=';
        }
        return atob(base64);
    }

    window.checkoutOnGoogleAuth = function(data) {
        $timeout(() => {
            $scope.credentials = data.credentials
            let decoded = jwtDecode(data.credential)
            if (decoded && decoded.email) {
                $scope.email = decoded.email
            }
            $scope.startTrial()
        })
    }

    $scope.getOrCreatePix = function() {
        api.createPixCharge({}).then(function(res) {
            $timeout(function() {
                $scope.pix.image = "data:image/png;base64," + res.data.encodedImage;
                $scope.pix.payload = res.data.payload;
                $scope.jobId = res.data.jobId;
                $scope.monitorJob(res.data.jobId);
            });
        })
        .catch(function(err) {
            console.log(err);
        })
    }

    let intervalCheckout= null;
    $scope.monitorJob = function(jobId) {
        if (intervalCheckout) {
            clearInterval(intervalCheckout);
        }
        if (!jobId) {
            showError(gettext('error.generic'))
            return;
        }
        intervalCheckout = setInterval(() => {
            api.getJob(jobId).then(res => {
                if (res.data && res.data.status != 'pending') {
                    clearInterval(intervalCheckout)
                    if (res.data && res.data.status == 'success') {
                        $scope.viewMode = 'register'
                        $timeout(angular.noop);
                        try {
                            track('Editor Trial Started')
                            track('Editor Paid Trial', {
                                method: 'pix',
                            })
                        } catch (e) {
                        }
                        clearInterval(intervalCheckout)
                    } else {
                        clearInterval(intervalCheckout)
                        showError(gettext('error.generic'), null, function () {
                            reloadLocation()
                        })
                    }
                }
            }).catch(e => {
                clearInterval(intervalCheckout)
                showError(gettext('error.generic'), null, function () {
                    reloadLocation()
                })
            })
        }, 2000)
    }

    $scope.copyPixCode = function() {
        if (!$scope.pix.payload) {
            return
        }
        navigator.clipboard.writeText($scope.pix.payload).then(function() {
            showSuccess(gettext('success.copy_clipboard'));
        }, function(err) {
            showError(gettext('error.generic'));
        });
    }

    $scope.startTrial = function(plan) {
        plan = plan || DEFAULT_PLAN;
        $scope.loading = true;

        var params = {
            plan: plan.id,
            quantity: plan.quantity,
            period: plan.period,
        };

        var coupon = null;
        try {
            coupon = localStorage.getItem('galilai.coupon');
        } catch (e) {}
        try {
            identifyUserData($scope.email);
        } catch (e) {}

        var planInput = {
            planId: plan.id,
            period: plan.period,
            quantity: plan.quantity,
            mode: $scope.plansMode,
            cancelURL: $location.absUrl(),
            coupon: coupon,
            tempId: $rootScope.userTempID,
        };

        if ($scope.plansMode === 'trial') {
            planInput.loginForm = getUserLoginForm($scope.email);
            if ($scope.credentials) {
                try {
                    planInput.loginForm.meta.google = $scope.credentials;
                } catch (e) {
                    console.log(e);
                }
            }
        }
        function handleRedirect(data) {
            if (data.token) {
                localStorage.setItem('auth.token', data.token);
            }
            if (data.url) {
                $rootScope.startCheckout(data, params);
            } else {
                goToEditor()
            }
        }

        function finalizeWithLoginModal(data) {
            $scope.loading = false;
            if ($rootScope.hideUpgrade) {
                $rootScope.hideUpgrade();
            }
            showLoginModal(function() {
                handleRedirect(data);
            }, true, {
                email: $scope.email
            }, autoSubmit = true);
        }

        api.upgradePlan(planInput).then(function(res) {
            var data = res.data;

            if (data && data.token) {
                localStorage.setItem('auth.token', data.token);
            }

            try {
                if (data && data.user && data.user._id) {
                    identifyUserWithId(data.user._id);
                }
            } catch (e) {}

            if (data && data.updated_plan) {
                if ($rootScope.hideUpgrade) {
                    $rootScope.hideUpgrade();
                }
                showSuccess(gettext('plan.upgraded'), null, function() {
                    handleRedirect(data);
                });
                return;
            }

            if (data && data.already_customer) {
                if (data.token) {
                    localStorage.setItem('auth.token', data.token);
                    setTimeout(function() {
                        handleRedirect(data);
                    }, 500);
                    return;
                }
                finalizeWithLoginModal(data);
                return;
            }

            if ($scope.plansMode === 'trial') {
                track('Editor Trial Open');
            }

            $timeout(function() {
                if (data.url) {
                    $rootScope.startCheckout(data, params);
                }
                $scope.loading = false;
            }, 200);

            if (!isLoggedIn()) {
                track('Editor Signup');
            }

            gtag('set', 'user_data', {
                email: $scope.email
            });

        }).catch(function(err) {
            console.log(err);
            showError(gettext('error.upgrade_plan'));
        }).finally(function() {
            $timeout(function() {
                $scope.loading = false;
            });
        });
    };

    $scope.doRegister = function() {
        // Validate email name and cpf
        if (!$scope.register.email || !$scope.register.name || !$scope.register.cpf) {
            showError(gettext('error.fill_required_fields'));
            return;
        }
        if (!validateCPF($scope.register.cpf)) {
            showError(gettext('error.fill_required_fields'));
            return;
        }
        let loginForm = getUserLoginForm($scope.register.email);
        loginForm.name = $scope.register.name
        loginForm.meta = loginForm.meta || {};
        if ($scope.register.cpf) {
            loginForm.meta.taxId = $scope.register.cpf;
        }
        $scope.loading = true;
        api.registerPaidUser({
            jobId: $scope.jobId,
            loginForm: loginForm,
        }). then(function(res) {
            if (!res?.data?.token || !res?.data?.success) {
                showError(gettext('error.generic'));
                return;
            }
            localStorage.setItem('auth.token', res.data.token);
            showSuccess(gettext('success.generic'), null, function() {
                goToEditor();
            })
            if (res?.data?.userId) {
                identifyUserWithId(res.data.userId);
            }
        }
        ).catch(function(err) {
            showError(gettext('error.generic'))
        })
        .finally(function() {
            $timeout(function() {
                $scope.loading = false;
            });
        });
    }

    $scope.init = function() {
        // Check if there is param in the url named px
        let params = new URLSearchParams(window.location.search);
        if (params.has('px')) {
            let landingItems = document.querySelector('[data-ref="landing-items"]');
            if (landingItems) {
                landingItems.remove();
            }
            $scope.viewMode = 'pix';
            $scope.started = true;
            $scope.getOrCreatePix();
            return;
        }
        $scope.viewMode = 'checkout';
        $scope.started = true;

        let interval = setInterval(() => {
            let input = document.getElementById('email')
            if (input) {
                input.focus()
                clearInterval(interval)
            }
        }, 100)
    }

})